import React, { useEffect } from 'react';
import { string } from 'prop-types';
import { useHelmet, TitleTag, MetaTag, LinkTag } from '@thd-nucleus/thd-helmet';

const metadataHandler = ({ props }) => {
  return [
    new TitleTag(props.title),
    new MetaTag({ name: 'description', content: props.description, id: 'description' }),
    new LinkTag({ rel: 'canonical', href: props.canonical, id: 'canonical' })
  ];
};

const PrivacyMetadata = (props) => {

  const { title, description, canonical } = props;

  useHelmet('privacyMetadata', { props }, metadataHandler, [title, description, canonical]);
  return null;
};

export { PrivacyMetadata };
